
import http from '@/utils/http';
import notify from '@/utils/notify'
import Api from '@/conf/Api';


export function CHAVE_PIX({ commit }, data) {
  return http.post(Api.supporter.chavePix, data)
    .then((r) => {
      notify(commit, r)
      return r
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function ENABLE({ commit, rootState }, enable) {

  if (rootState.user.usuario.perfil !== 'agregado_doutor') {
    let type = enable ? 'put' : 'delete'
    return http[type](Api.supporter.enable).then((r) => {
      if (r.status == 200 || r.status == 201) commit('ENABLE_SET', enable)
      notify(commit, r)
      return r
    }).catch((e) => {
      notify(commit, e)
      return e
    })
  }

}
export function ENABLE_GET({ commit, rootState }) {
  if (rootState.user.usuario.perfil !== 'agregado_doutor') {
    return http.get(Api.supporter.enable).then((r) => {
      commit('ENABLE_SET', r.data.disponibilidade)
    }).catch((e) => {
      notify(commit, e)
    })
  }
}




